import { IconBaseProps } from 'react-icons';

import { LuClock, LuMail } from 'react-icons/lu';

const stylesheet = {
  wrapper: 'relative inline-flex flex-shrink-0',
  badgeBackdrop:
    'absolute -bottom-[4%] -right-[15%] flex h-[80%] w-[80%] items-center justify-center rounded-full bg-semantic-bg-surface p-[10%]',
  badgeIcon: 'h-full w-full text-semantic-text-primary',
};

export function ScheduledMailIcon({
  className,
  ...props
}: Readonly<IconBaseProps>) {
  return (
    <span className={stylesheet.wrapper}>
      <LuMail {...props} className={className} />
      <span className={stylesheet.badgeBackdrop} aria-hidden="true">
        <LuClock className={stylesheet.badgeIcon} />
      </span>
    </span>
  );
}
